import { HStack, Image, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { sponsor_content_clicked } from '@/analytics';
import { Card } from '@/imports/ui/chakra/components/Card';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

export type AdditionalSponsorOrganization = {
  _id: string;
  name: string;
  profilePicture?: {
    imageProxy: string | null;
  } | null;
};

export const AdditionalSponsorsCard: React.FC<{
  title: string;
  organizations: AdditionalSponsorOrganization[];
}> = ({ title, organizations }) => {
  if (!organizations.length) {
    return null;
  }

  return (
    <Card py="6" px="4">
      <Stack spacing="3">
        <Text
          textStyle="compactStrong"
          color="gray.600"
          textTransform="uppercase"
        >
          {title}
        </Text>

        <Stack spacing="3">
          {organizations.map((sponsor) => {
            return (
              <NextLink
                key={sponsor._id}
                href={`/companies/${sponsor._id}`}
                onClick={() => {
                  sponsor_content_clicked({
                    sponsor_id: sponsor._id,
                    sponsor_name: sponsor.name,
                    sponsor_content_type: 'event_sponsor_card',
                    sponsor_content_id: sponsor._id,
                    sponsor_interaction_source: 'event',
                    location_organization_id: sponsor._id,
                  });
                }}
              >
                <Card
                  p="4"
                  shadow="xs"
                  _hover={{ bg: 'gray.50' }}
                  cursor="pointer"
                >
                  <HStack spacing="4">
                    <Image
                      boxSize="48px"
                      src={sponsor.profilePicture?.imageProxy ?? undefined}
                      alt={sponsor.name}
                      borderRadius="sm"
                      fallback={
                        <ImageFallback borderRadius="sm" boxSize="48px" />
                      }
                    />

                    <Text textStyle="bodyStrong" noOfLines={1}>
                      {sponsor.name}
                    </Text>
                  </HStack>
                </Card>
              </NextLink>
            );
          })}
        </Stack>
      </Stack>
    </Card>
  );
};
